import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  color: rgb(51, 51, 51);\n  ", "\n  ", "\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n      margin: ", ";\n    "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import React from 'react';
import styled, { css } from 'styled-components';
import GroupContext from './GroupContext';
import { GroupHelperText } from '../../shared/input';
import { legacySwappableCss } from '../../theme'; // LEGACY theme

var legacyContainerCss = 'margin: 3px 0px 7px 0px;';
var legacyLabelCss = "\n  margin-bottom: 10px;\n  font-size: 18px;\n  font-weight: 300;\n"; // END LEGACY theme

var RadioGroupContainer = styled.div(_templateObject(), legacySwappableCss(legacyContainerCss, css(_templateObject2(), function (p) {
  return p.theme.spacing(2);
})));
var Label = styled.div(_templateObject3(), function (p) {
  return p.theme.fontCss('body', true);
}, legacySwappableCss(legacyLabelCss, ''));

var RadioGroupInput = function RadioGroupInput(_ref) {
  var name = _ref.name,
      children = _ref.children,
      value = _ref.value,
      onChange = _ref.onChange,
      disabled = _ref.disabled,
      label = _ref.label,
      hasError = _ref.hasError,
      helperText = _ref.helperText;
  return /*#__PURE__*/React.createElement(GroupContext.Provider, {
    value: {
      name: name,
      value: value,
      onChange: onChange,
      disabled: disabled
    }
  }, /*#__PURE__*/React.createElement(Label, {
    id: "".concat(name, "-label")
  }, label), /*#__PURE__*/React.createElement(RadioGroupContainer, {
    role: "radiogroup",
    "aria-labelledby": "".concat(name, "-label")
  }, children), helperText && /*#__PURE__*/React.createElement(GroupHelperText, {
    hasError: hasError
  }, helperText));
};

export default RadioGroupInput;